import { useStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { devtools as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
//#region src/lib/stores/is-olympus-ready-store/useIsOlympusReadyStore.ts
var i = t(r((e, t) => ({
	isOFReady: !1,
	setOFReady: () => {
		t().isOFReady || e({ isOFReady: !0 });
	}
}))), a = (t) => e(i, n(t));
//#endregion
export { i as isOlympusReadyStore, a as useIsOlympusReadyStore };
